// EAA-1662: the product's display name lives in exactly one place. It used to be a
// literal repeated in the sidebar logo, the login/callback cards and index.html, so a
// rename meant hunting every copy. Override per deployment with VITE_APP_NAME; the
// fallback is the current product name.
export const APP_NAME: string = import.meta.env.VITE_APP_NAME || 'AI Content Studio';

/** Used for <meta name="description"> and any place that wants a one-line blurb. */
export const APP_DESCRIPTION: string = `${APP_NAME} - AI-powered content assistant`;
